<template>
  <v-app>
    <v-app-bar color="success" app>
      <v-toolbar-title
        class="hidden-md-and-up hidden-xs-only .subtitle-2 #db1414--text font-weight-black"
      >
        Are you on the naughty list?
      </v-toolbar-title>
      <v-toolbar-title class="hidden-sm-and-up #db1414--text font-weight-black">
        Naughty list
      </v-toolbar-title>
      <v-toolbar-title class="hidden-sm-and-down display-1 #db1414--text font-weight-black">
        Are you on the naughty list?
      </v-toolbar-title>
      <v-spacer />
      <v-col cols="3" sm="2" md="1" v-if="!signedIn">
        <v-btn
          @click.stop="signUp = false; loginOpen = true; deleteMode = false"
          dark
          color="#db1414"
        >
          Login
        </v-btn>
      </v-col>
      <v-col cols="3" v-if="!signedIn" sm="2" md="1">
        <v-btn
          @click.stop="signUp = true; loginOpen = true; deleteMode = false"
          dark
          color="#db1414"
        >
          Sign Up
        </v-btn>
      </v-col>
      <v-col cols="3" sm="2" md="1" v-if="signedIn">
        <v-btn @click.stop="logout" color="#db1414" dark>
          Log out
        </v-btn>
      </v-col>
      <v-col cols="3" sm="2" md="1" v-if="signedIn">
        <v-btn @click.stop="deleteAccount" color="#db1414" dark>
          Delete
        </v-btn>
      </v-col>
    </v-app-bar>
    <v-content style="background: #db1414;">
      <login v-model="loginOpen" :deleteMode="deleteMode" :signUp="signUp" @login="onLogin"/>
      <v-container v-if="signedIn">
        <v-row>
          <v-col cols="12">
            <v-text-field
              solo
              color="#db1414"
              background-color="#4CAF50"
              label="Check naughty status"
              persistent-hint
              hint="Check naughty status"
              dark
              v-model="naughtyListCheck"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn
              color="success"
              class="text-none"
              @click="isOnNaughtyList(naughtyListCheck)">Check naughty status</v-btn>
          </v-col>
        </v-row>
        <v-row class="title">
          <v-col cols="12">
            <p
              style="border-radius: 10px; padding: 5px;"
              :class="naughty === true
                ? 'white red--text'
                : ( naughty === false ? 'white green--text' : 'white')"
            >
              Naughty status: {{naughty === true ? 'Naughty' : ( naughty === false ? 'Nice' : '')}}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              solo
              color="#db1414"
              background-color="#4CAF50"
              persistent-hint
              label="Update naughty status"
              hint="Update naughty status"
              dark
              v-model="naughtyListChange"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12">
            <v-btn
              @click="setNaughtyValue(naughtyListChange, true)"
              color="white"
              class="red--text text-none"
            >Add {{naughtyListChange}} to the naughty list</v-btn>
          </v-col>
          <v-col cols="12" sm="12">
            <v-btn
              @click="setNaughtyValue(naughtyListChange, false)"
              color="white"
              class="success--text text-none"
            >Remove {{naughtyListChange}} from the naughty list</v-btn>
          </v-col>
        </v-row>

        <v-row class="title white--text">
          <v-col>
            {{naughtyChange}}
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else class="display-1 white--text">
        Please Log In
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import * as firebase from 'firebase/app';

import Login from './components/Login.vue';
import encryptor from './util/encypt';

import 'firebase/auth';
import 'firebase/firestore';


export default {
  name: 'app',
  components: {
    Login,
  },

  async created() {
    if (localStorage.getItem('user')) {
      this.onLogin(JSON.parse(localStorage.getItem('user')));
    }
  },

  data: () => ({
    loginOpen: false,
    signUp: false,
    deleteMode: false,
    user: {},
    groupInfo: {},
    naughtyListCheck: '',
    naughty: '',
    naughtyListChange: '',
    naughtyChange: '',
    signedIn: false,
  }),

  methods: {
    async onLogin(credentails) {
      if (credentails.signUp) {
        if (!credentails.email || !credentails.password || !credentails.username) {
          window.alert('missing required fields');
          return;
        }
        if ((await firebase.firestore().collection('emailmap').doc(credentails.username).get()).data()) {
          window.alert('email already in use');
        }
        try {
          await firebase.auth()
            .createUserWithEmailAndPassword(credentails.email, credentails.password);
        } catch (e) {
          window.alert('sign up error (Account may already exist)');
          console.error(e);
          return;
        }
        await firebase.firestore().collection('emailmap').doc(credentails.username)
          .set({ value: credentails.email });
        this.user.username = credentails.username;
        this.user.password = credentails.password;
        localStorage.setItem('user', JSON.stringify(this.user));
      } else {
        if (!credentails.password || !credentails.username) {
          window.alert('missing required fields');
          return;
        }
        const email = (await firebase.firestore().collection('emailmap').doc(credentails.username).get()).data();
        console.log('email', email);
        if (!email) {
          window.alert('account not found');
          return;
        }
        try {
          await firebase.auth().signInWithEmailAndPassword(email.value, credentails.password);
        } catch (e) {
          window.alert('sign in error (Account may not exist)');
          console.error(e);
          return;
        }
        this.user.username = credentails.username;
        this.user.password = credentails.password;
        localStorage.setItem('user', JSON.stringify(this.user));
      }
      if (credentails.deleteMode) {
        await this.deleteAccount();
      }
      await firebase.firestore().collection('groups').doc(firebase.auth().currentUser.uid).onSnapshot(data => this.get(data));
      this.signedIn = true;
    },

    async get(document) {
      if (!document) return;
      console.log('getting data', this.user, document);
      const encryptedData = document.data();
      let data = {};
      if (encryptedData) {
        const toParse = encryptor.decrypt(encryptedData.value, this.user.password);
        console.log('Data get json', toParse);
        data = JSON.parse(toParse);
      }
      this.groupInfo = data;
      console.log('Data get', data);
    },

    isOnNaughtyList(name) {
      console.log('Checking', this.groupInfo, name.trim().toLowerCase());
      if (!this.groupInfo[name.trim().toLowerCase()]) {
        this.naughty = false;
        clearTimeout(this.isTime);
        this.isTime = setTimeout(() => {
          this.naughty = null;
        }, 5000);
        return;
      }
      if (this.groupInfo[name.trim().toLowerCase()].naughty) {
        this.naughty = true;
      } else {
        this.naughty = false;
      }
      clearTimeout(this.isTime);
      this.isTime = setTimeout(() => {
        this.naughty = null;
      }, 10000);
    },

    async setNaughtyValue(name, value) {
      if (!this.groupInfo[name.toLowerCase().trim()]) {
        this.groupInfo[name.toLowerCase().trim()] = {};
      }
      this.groupInfo[name.toLowerCase().trim()].naughty = value;
      await this.update();
      this.naughtyChange = 'Sent request to Santa';
      clearTimeout(this.setTime);
      this.setTime = setTimeout(() => {
        this.naughtyChange = '';
      }, 6000);
    },

    async update() {
      console.log('updating');
      const encypted = encryptor.encrypt(JSON.stringify(this.groupInfo), this.user.password);
      await firebase.firestore().collection('groups').doc(firebase.auth().currentUser.uid).set({
        value: encypted,
      });
    },

    logout() {
      localStorage.clear();
      this.signedIn = false;
      firebase.auth().signOut();
    },

    async deleteAccount() {
      if (!window.confirm('Are you sure you want to delete your naughty list?')) return;
      firebase.firestore().collection('groups').doc(firebase.auth().currentUser.uid).delete()
        .then(() => {
          firebase.firestore().collection('emailmap').doc(this.user.username).delete();
        });
      try {
        await firebase.auth().currentUser.delete();
      } catch (e) {
        if (e.code === 'auth/requires-recent-login') {
          this.signUp = false;
          this.loginOpen = true;
          this.deleteMode = true;
          return;
        }
        throw e;
      }
      console.log('Deleting', this.user);


      localStorage.clear();
      this.signedIn = false;
      firebase.auth().signOut();
      window.location.reload();
      console.log('Finish delete', this.user);
    },
  },
};
</script>
